const config = {
  apiEndPointUrl: process.env.REACT_APP_API_ENDPOINT_URL,
  recaptchaKey: '6LdwoLwZAAAAAKvNGYeljXWO6VQ-dNlGadSI34sU',
};

export default config;